import { LegacyAlarmsScreen } from "@src/features/alarms/screens/LegacyAlarmsTab.native";

export default function AlarmsScreen() {
  return <LegacyAlarmsScreen />;
}
